import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_GUILD_DETAILS } from '../actions/getGuildDetails';
import {
  SET_GUILD_BOSS_KILL_DETAILS,
  SHOW_GUILD_BOSS_KILL_LOADING_SPINNER,
  SET_GUILD_DETAILS_TABLE_BOSS_RANKINGS,
  TOGGLE_OPEN_GUILD_DETAILS_TABLE,
  SET_GUILD_BOSS_KILL_FORCE_REFRESH,
  DEFAULT_RAID_CATEGORY_TO_OPEN,
  SET_SELECTED_GUILD_KILL_VIDEO
} from '../actions/guildActionCreator';
import { SET_GUILD_PAGE_LOADING } from '../actions/setGuildPageLoading';
import { TAction } from '../actions/types/action';

function getDefaultState() {
  return {
    openSections: {},
    loadedSections: {},
    loadingSections: {},

    bossKills: {} as any,
    loadingBossKills: {},
    forceRefreshBossKills: {}
  };
}

export default function guildDetails(state: Partial<any> = getDefaultState(), action: TAction<any>): Partial<any> {
  switch (action.type) {
    case DEFAULT_RAID_CATEGORY_TO_OPEN: {
      const key = `${action.payload.raid}-${action.payload.difficulty}`;
      const newState: any = {
        ...state,
        openSections: { ...state.openSections, [key]: true }
      };
      return newState;
    }
    case GET_GUILD_DETAILS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SET_GUILD_PAGE_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case TOGGLE_OPEN_GUILD_DETAILS_TABLE: {
      const key = `${action.payload.raid}-${action.payload.difficulty}`;
      const newState: any = {
        ...state,
        openSections: {
          ...state.openSections,
          [key]: state.openSections[key] !== undefined ? !state.openSections[key] : true
        }
      };
      return newState;
    }
    case SET_GUILD_DETAILS_TABLE_BOSS_RANKINGS: {
      const key = `${action.payload.raid}-${action.payload.difficulty}-${action.payload.guildId}`;
      const newState: any = {
        ...state
      };
      newState.loadedSections[key] = action.payload.bossRankings;
      return newState;
    }
    case SET_GUILD_BOSS_KILL_DETAILS: {
      return {
        ...state,
        bossKills: {
          ...state.bossKills,
          [action.payload.key]: action.payload.details
        },
        loadingBossKills: {
          ...state.loadingBossKills,
          [action.payload.key]: false
        },
        forceRefreshBossKills: {
          ...state.forceRefreshBossKills,
          [action.payload.key]: false
        }
      };
    }
    case SET_SELECTED_GUILD_KILL_VIDEO: {
      return {
        ...state,
        bossKills: {
          ...state.bossKills,
          [action.payload.key]: {
            ...state.bossKills[action.payload.key],
            selectedVideo: {
              ...action.payload.video,
              autoPlay: true
            }
          }
        }
      };
    }
    case SET_GUILD_BOSS_KILL_FORCE_REFRESH: {
      return {
        ...state,
        forceRefreshBossKills: {
          ...state.forceRefreshBossKills,
          [action.payload.key]: true
        }
      };
    }
    case SHOW_GUILD_BOSS_KILL_LOADING_SPINNER: {
      return {
        ...state,
        loadingBossKills: {
          ...state.loadingBossKills,
          [action.payload.key]: action.payload.show
        },
        forceRefreshBossKills: {
          ...state.forceRefreshBossKills,
          [action.payload.key]: false
        }
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      // Check if the 'vod' variable is present in the action.payload.location.hash
      if (action.payload.location.hash.includes('vod')) {
        return state;
      }
      return getDefaultState();
    }
    default: {
      return state;
    }
  }
}
